import { INIT_INDEX, POS_NEG_LINE } from 'util/constants';

export const isEmpty = value => value === undefined || value === null || value === '' || (value instanceof Array && !value.length) ? 'empty' : undefined;

export const nonWhiteSpaces = value => {
    if (/\S/.test(value)) {

        return undefined;
    }

    return 'empty';

};

export const maxLength = max => {
    if (typeof max !== 'number' || max < POS_NEG_LINE) {
        throw new Error('maxLength needs a positive number');
    }

    return value => {
        if (typeof value !== 'string') {
            throw new Error('maxLength needs a string to validate');
        }

        return value.length > max ?
            {msg: 'must_be_max_length', par: {maxlength: max}} :
            undefined;
    };
};

export const joinValidators = validators => {
    if (!(validators instanceof Array)) {
        throw new Error('joinValidators needs an array');
    }

    return (value, data) => validators.reduce((ret, validator) => ret || validator(value, data), undefined);
};

export const match = field => (value, data) => {
    if (data) {
        if (value !== data[field]) {
            return {
                msg: 'do_no_match',
                par: {field}
            };
        }
    }

    return undefined;
};

export const regexp = (pattern, patternText) => value => {
    if (!pattern.test(value)) {
        return {
            msg: 'invalid_exp',
            par: {pattern: patternText}
        };
    }

    return undefined;
};

const join = rules => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[INIT_INDEX];


/* eslint-disable */
export function email(value) {
	if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
		return 'invalid_email'; //'Invalid email address';
	}
}

export function required(value) {
	if (isEmpty(value)) {
		return 'is_required';
	}
}

export function minLength(min) {
	return value => {
		if (!isEmpty(value) && value.length < min) {
			return {msg: 'must_be_min_length', par: {min: min}}; //`Must be at least ${min} characters`;
		}
	};
}

export function uppercase(value) {
    if (!/[A-Z]/.test(value)) {
      return 'must_contain_uppercase'
    }
  }
  
export function lowercase(value) {
    if (!/[a-z]/.test(value)) {
      return 'must_contain_lowercase'}
    }   
  
export function numbers(value) {
    if (!/\d/.test(value)) {
      return 'must_contain_numbers'
    }
  }

  export function specialCharacter(value) {
    if (!/[^A-Za-z0-9]/.test(value)) {
      return 'must_contain_special_character'
    }
  }

export function integer(value) {
	if (!Number.isInteger(Number(value))) {
		return 'must_be_integer'; //'Must be an integer';
	}
}

export function oneOf(enumeration) {
	return value => {
		if (!~enumeration.indexOf(value)) {
			return 'must_be_one_of'; //`Must be one of: ${enumeration.join(', ')}`;
		}
	};
}

export function createValidator(formName, rules) {
	return (data = {}) => {
		const errors = {};
		Object.keys(rules).forEach((key) => {
			const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
			const error = rule(data[key], data);
			if (error) {
				errors[key] = 'form.' + formName + '.' + key + '.error.' + error;
			}
		});
		return errors;
	};
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/validation.js